import moment from 'moment-timezone'

/**
 * Configuration composable
 * Provides easy access to runtime configuration values
 */
export const useDate = () => {
  const i18n = useI18n()

  return {
    formatShortDateTime: (dateTime: number): string => {
      return `${i18n.d(new Date(dateTime), 'shortDate')} ${i18n.d(new Date(dateTime), 'time')}`
    },

    formatDate: (date: string): string => {
      return i18n.d(date, 'fullDate')
    },

    todayDate: (): string => {
      return new Date().toISOString().split('T')[0]
    },
    formatTimeWithTimezone: (dateTimeString: string, timezone: string = 'UTC'): string => {
      return moment.utc(dateTimeString).tz(timezone).format('HH:mm')
    }
  }
}
